$(document).ready(function() {
 $("#product-detail-carousel").owlCarousel({
        center: false,
        dots:false,
        loop: false,
        nav: true,
         rewindNav : false,
        margin:5,
        autoplay: false,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,   
        responsive:{
          0:{
            items:1,
            nav: true,
            
          },
          767:{
            items:1,
            nav: true,
          },
          768:{
            items:3,
            nav: true,
          }
        }
      })
        $( "#product-detail-carousel .owl-prev").html('<i class="fa fa-angle-left"></i>');
     $( "#product-detail-carousel .owl-next").html('<i class="fa fa-angle-right"></i>');
  $('#trigger').click(function() {
    $('#overlay').fadeIn(300);  
  });
  $('#overlay').click(function() {
    $('#overlay').fadeOut(300);
  });
  $('#close').click(function() {
    $('#overlay').fadeOut(300);
  });
});
$(document).ready(function() {
  $('#triggered').click(function() {
    $('#overlayed').fadeIn(300);  
  });
  $('#overlayed').click(function() {
    $('#overlayed').fadeOut(300);
  });
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}
$(document).ready(function(){
$('.product_tumb_slide').slick({
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 5,
  slidesToScroll: 1
});


$('.slick_thum_mobile').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
    infinite: true
});
});
$('.ultimat_page_slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
    infinite: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        centerPadding: '30px',
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

});

$('.slider_three_fitings').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
    infinite: true,
          dots: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        centerPadding: '30px',
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

});




$('.whichshoes_like').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
    infinite: true,
          dots: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        centerPadding: '30px',
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

});



$('.cust_pro_slick').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
         centerMode: true,
        centerPadding: '30px',
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.slider_once_vop').slick({
  slidesToShow: 5,
  slidesToScroll: 5,
    infinite: true,
          dots: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        centerPadding: '30px',
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

});


$('.slick_oneoverstagr').slick({
  dots: true,
  infinite: false,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
 
  });



$('.softsloe_page').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  
  
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: false,
        centerPadding: '30px',
        dots: false
      }
    }
    
  ]
  });




$('.xplore_slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  
  
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        centerPadding: '30px',
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object   mobile_slidertabs
  ]
  });

$('.stepup_sf_page').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  
  
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        centerPadding: '30px',
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object   mobile_slidertabs
  ]
  });




$('.stepup_sf_pagetyu').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  
  
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        centerPadding: '30px',
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object   mobile_slidertabs
  ]
  });




$('.stepup_sf_pammmgetyu').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  
  
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        centerPadding: '30px',
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object   mobile_slidertabs
  ]
  });













$('.hello_newhj_popy').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  
  
   responsive: [
    {
      breakpoint: 1439,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        centerMode: true,
        arrows: true,
 

      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
        centerMode: true,
        arrows: true,
 

      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
         centerMode: true,
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         centerMode: true,
        dots: false,
        arrows: true,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object   mobile_slidertabs
  ]
  });

////utlimate health

$('#mobile_slidvvertabs').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  });

$('.responseive').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  });




$('.slickgrabng').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  });



$('.mobile_skides_prd').slick({
  dots: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  });


$('.hello_taabslider').slick({
  dots: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  });


$('.manufacturing_secondslide').slick({
  dots: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  });

$('.mobile_slidertabs').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  });
$('.slick_one').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  });
$('.slick_onessd').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  });
$('.multiple-items').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  infinite: true,
  arrows: true,
});
	$(document).ready(function() {    

$('#tabs li a:not(:first)').addClass('inactive');
$('.container').hide();
$('.container:first').show();
    
$('#tabs li a').click(function(){
    var t = $(this).attr('id');
  if($(this).hasClass('inactive')){ //this is the start of our condition 
    $('#tabs li a').addClass('inactive');           
    $(this).removeClass('inactive');
    
    $('.container').hide();
    $('#'+ t + 'C').fadeIn('slow');
 }
});

});
///swatch js
$(document).ready(function() {
  if($("input[type='radio'].swatch_radio").is(':checked')) {
    var card_type = $("input[type='radio'].swatch_radio:checked").val();
    var card_left = $("input[type='radio'].swatch_radio:checked").attr("drt_value");
    // alert(card_type);
    $("#myDiv").text(card_type);
    $("#mydivt").text(card_left); 
  }
});
$(".swatch_radio") // select the radio by its id
.change(function(){ // bind a function to the change event
  if( $(this).is(":checked") ){ // check if the radio is checked
    var val = $(this).val(); // retrieve the value
    var drt_value = $(this).attr("drt_value");
    $("#myDiv").text(val);
    $("#mydivt").text(drt_value);
  }
});
//end swatch js


//     $(document).ready(function() {
//       $(".product_page").owlCarousel({
//         center: false,
//         dots:false,
//         loop: true,
//         nav: true,
//          rewindNav : false,
//         margin:5,
//         autoplay: false,
//         autoplayTimeout: 2000,
//         autoplayHoverPause: true,   
//         responsive:{
//           0:{
//             items:1,
//             nav: true,
            
//           },
//           600:{
//             items:3,
//             nav: true,
//           },
//           1000:{
//             items:5,
//             nav: true,
//           }
//         }
//       })
//       $( ".owl-prev").html('<i class="fa fa-angle-left"></i>');
//       $( ".owl-next").html('<i class="fa fa-angle-right"></i>');
//     });

 
///swatch js
$(document).ready(function() {
   var detachedContent = $('.cartupsell').detach();
      detachedContent.appendTo('.allupsell');
  if($("input[type='radio'].swatch_radio").is(':checked')) {
    var card_type = $("input[type='radio'].swatch_radio:checked").val();
    var card_left = $("input[type='radio'].swatch_radio:checked").attr("drt_value");
    // alert(card_type);
    $("#myDiv").text(card_type);
    $("#mydivt").text(card_left); 
  }
});
$(".swatch_radio") // select the radio by its id
.change(function(){ // bind a function to the change event
  if( $(this).is(":checked") ){ // check if the radio is checked
    var val = $(this).val(); // retrieve the value
    var drt_value = $(this).attr("drt_value");
    $("#myDiv").text(val);
    $("#mydivt").text(drt_value);
  }
});
//end swatch js

$('.last_tab_slide').slick({
  dots: true,
  infinite: false,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
 
  });


$(document).ready(function() {

  var description = $(".custom-description .description-content");
  var toggle = $(".custom-description .description-toggle a");

  // Initially, hide the "See More" link
  toggle.hide();

  // Add a click event to the "See More" link
  toggle.on("click", function(e) {
    e.preventDefault();
    $(".custom-description").addClass("expanded"); // Expand the description
    toggle.hide(); // Hide the "See More" link

    // Scroll to the "more-content" section with an ID
    $("html, body").animate({
      scrollTop: $("#more-content").offset().top
    }, 500);
  });


  
});
